import { render, staticRenderFns } from "./work-item-modal-reprocess.component.vue?vue&type=template&id=1bc74690&"
import script from "./work-item-modal-reprocess.component.vue?vue&type=script&lang=ts&"
export * from "./work-item-modal-reprocess.component.vue?vue&type=script&lang=ts&"
import style0 from "./work-item-modal-reprocess.component.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports